import Index from './Index.vue';

export default {
  path: 'aditivos',
  name: 'produto-aditivo',
  component: Index,
};
